<template>
    <div class="pandoraMenuitem">
        <a v-if="props.href" :href="props.href" role="button" :aria-label="props.text ?? ''"
            :class="[titleactive == props.text && 'isActive']">{{ props.text }}</a>
        <a v-else role="menu" :aria-label="props.text ?? ''" :class="[titleactive == props.text && 'isActive']">{{
            props.text }}</a>
        <slot></slot>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    text: {
        type: String,
        default: ''
    },
    href: {
        type: String,
        default: ''
    },
    titleactive: {
        type: String,
        default: ''
    }
});
</script>

<style scoped>
.pandoraMenuitem {
    position: relative;
    display: block;
    opacity: 0;
    cursor: pointer;
    text-align: left;
}


.menuContainer>.pandoraMenu>.pandoraMenuitem {
    pointer-events: all;
    opacity: 1;
}

.menuContainer a {
    background: #FFF;
    color: #444;
    text-decoration: none;
    width: inherit;
    transition: background 0.5s, color 0.5s, transform 0.5s;
    margin: 0px 6px 3px 0px;
    padding: 6px 7px;
    box-sizing: border-box;
    border-radius: 3px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
    position: relative;
    font-family: Rubik, sans-serif;
    font-size: 13px;
}

.pandoraMenu .pandoraMenuitem a {
    white-space: nowrap;
    display: block;
}

.menuContainer>.pandoraMenu>.pandoraMenuitem>a {
    background: #00805D;
    color: #FFF;
    text-decoration: none;
}

.isActive {
    background: #7FC343 !important;
}

.menuContainer {
    margin-top: 40px;
    margin-left: 40px;
}

.menuContainer a:hover:before {
    content: '';
    top: 0;
    left: 0;
    position: absolute;
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.1);
    width: 100%;
    height: 100%;
}

.menuContainer>.pandoraMenu>.pandoraMenuitem>.pandoraMenu>.pandoraMenuitem {
    transition: transform 0.3s, opacity 0.3s;
    transform: translateY(150%);
    opacity: 0;
}

.pandoraMenuitem>.pandoraMenu>.pandoraMenuitem>.pandoraMenu>.pandoraMenuitem {
    transition: transform 0.1s, opacity 0.1s;
    transform: translateX(195px) translateY(0%);
    opacity: 0;
}

.menuContainer>.pandoraMenu>.pandoraMenuitem:hover>.pandoraMenu>.pandoraMenuitem,
.menuContainer>.pandoraMenu>.pandoraMenuitem.hover>.pandoraMenu>.pandoraMenuitem {
    transform: translateY(0%);
    opacity: 1;
}

.pandoraMenuitem>.pandoraMenu>.pandoraMenuitem:hover>.pandoraMenu>.pandoraMenuitem,
.pandoraMenuitem>.pandoraMenu>.pandoraMenuitem.hover>.pandoraMenu>.pandoraMenuitem {
    transform: translateX(0) translateY(0%);
    opacity: 1;
}
</style>